import React from "react";

const styles = {
  wrapper: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #0f2027, #203a43, #2c5364)",
    color: "#ffffff",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    padding: "24px",
  },
  card: {
    maxWidth: "520px",
    width: "100%",
    background: "rgba(255, 255, 255, 0.08)",
    borderRadius: "16px",
    padding: "40px 32px",
    textAlign: "center",
    boxShadow: "0 20px 40px rgba(0,0,0,0.35)",
    backdropFilter: "blur(12px)",
  },
  icon: {
    fontSize: "48px",
    marginBottom: "16px",
  },
  title: {
    fontSize: "28px",
    fontWeight: 600,
    marginBottom: "12px",
  },
  subtitle: {
    fontSize: "16px",
    lineHeight: 1.5,
    opacity: 0.9,
    marginBottom: "28px",
  },
  divider: {
    height: "1px",
    background: "rgba(255,255,255,0.2)",
    margin: "24px 0",
  },
  footer: {
    fontSize: "13px",
    opacity: 0.75,
  },
};

export default function UnderConstruction() {
  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <div style={styles.icon}>🚧</div>

        <div style={styles.title}>Under Construction</div>

        <div style={styles.subtitle}>
          This application is temporarily unavailable. Please check back shortly.
        </div>

        <div style={styles.divider} />

        <div style={styles.footer}>
          If you reached this page unexpectedly, no action is required.
        </div>
      </div>
    </div>
  );
}